'use client';

import { useState } from 'react';
import classNames from 'classnames';
import useUser from '@/utils/use-user';
import UserOrderModal from './user-order-modal';
interface Props {
  showDevice: 'mobile' | 'desktop';
}
function FollowUpOrder({
  showDevice
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const {
    isLoggedIn
  } = useUser();
  return <>
            <span className={classNames('text-body-14 font-medium md:text-body-16', showDevice === 'mobile' ? 'col-span-full mb-6 block text-center md:hidden' : 'hidden md:block')}>
                برای پیگیری سفارش{' '}
                {isLoggedIn ? <a href='/profile/orders' className='text-alert-info-dark'>
                        اینجا
                    </a> : <button onClick={() => setIsOpen(true)} type='button' className='text-alert-info-dark'>
                        اینجا
                    </button>}{' '}
                کلیک کنید.
            </span>
            <UserOrderModal isOpen={isOpen} handleClose={() => setIsOpen(false)} data-sentry-element="UserOrderModal" data-sentry-source-file="follow-up-order.tsx" />
        </>;
}
export default FollowUpOrder;